export const Connectwallethandler = (payload) => (dispatch) => {
  dispatch({
    type: "CONNECT_WALLET",
    payload,
  });
};
